module.exports = __webpack_public_path__ + "static/media/illustration-nenhum-chat.7672774a.svg";